/**
 * The participation ("Teilnahme") question's wire contract.
 *
 * AUDIT 2026-08-14. The acceptance widget used to submit under whatever
 * `inputFieldVariable` the page declared, falling back to `"acceptanceState"`
 * when no node declared one — which is EVERY wizard-generated site, because no
 * template, wizard injection or DSL compiler has ever emitted an acceptance
 * node. The worker drops `acceptanceState` from a public submission on
 * purpose: it is the organiser's verdict on a registration request, and a
 * visitor who could write it could approve their own. So the Zusage was
 * discarded silently — 200, no write, no "Gast hat zugesagt" automation,
 * nothing in the guest's history.
 *
 * `state` is the guest's OWN answer and has always been a writeable core
 * column on that door. It is therefore the only correct wire key, regardless
 * of what a stored page says — hence a constant rather than a fallback.
 *
 * Why nobody noticed: `App.tsx` STATUS_ALIASES mirrors the answer into all
 * three spellings of the LIVE VISIBILITY MAP, so the fields gated on
 * `state = ACCEPTED` revealed correctly. The form behaved perfectly; only the
 * POST body was wrong.
 */
export const ACCEPTANCE_SUBMIT_VARIABLE = "state";

/** Both spellings of the participation question collapse to the wire key. */
export function canonicalFieldVariable(variable: string): string {
  return variable === "state" || variable === "acceptanceState"
    ? ACCEPTANCE_SUBMIT_VARIABLE
    : variable;
}

/**
 * Only a real ANSWER pre-selects a button.
 *
 * The prefill reads `session.user[fieldVariable]`. Under the old key that was
 * `acceptanceState`, which only ever holds ACCEPTED / PENDING / DECLINED /
 * SYSTEM — so a raw pass-through looked harmless. `state` also holds
 * UNCONTACTED, CONTACTED and WAITLISTED, and passing one of those through
 * would render with no button highlighted while `required && !selected` reads
 * FALSE (a truthy string): the required check silently passes and the form
 * posts an RSVP answer the guest never gave.
 */
export function normalizeAcceptancePrefill(raw: unknown): string {
  return raw === "ACCEPTED" || raw === "DECLINED" ? raw : "";
}
